<div class="accordion" id="accordionExample" style="margin-top: -30px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button aria-controls="collapse0" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse0" data-bs-toggle="collapse" type="button">
                Aangifte en inkomen
            </button>
        </h2>
        <div aria-labelledby="heading0" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse0">
            <div class="accordion-body">
                Met de aangifte inkomstenbelasting wordt een (belastbaar) inkomen berekend. Om te bepalen hoeveel
                belasting de belastingplichtige moet betalen, worden de inkomsten in 3 groepen. Deze groepen noemen we
                boxen. Dat zijn: <br/>
                <div class="space10"></div>

                <ul>
                    <li>
                        box 1: inkomen uit werk en woning.<br/>
                        Denk hierbij aan loon, winst uit onderneming, eigen woning of een AOW-uitkering.
                    </li>
                    <li>
                        box 2: inkomen uit aanmerkelijk belang<br/>
                        Inkomen in box 2 komt voor bij bezit van minimaal 5% aandelen of andere rechten in een
                        vennootschap.
                    </li>
                    <li>
                        box 3: inkomen uit sparen en beleggen<br/>
                        Denk hierbij aan vermogen, zoals spaargeld of een 2e woning.
                    </li>
                </ul>

                In elke box betaal je over een ander deel van het inkomen belasting. Dat zijn de tarieven en deze zijn
                voor elke box anders. Ook zijn er misschien aftrekposten en heffingskortingen waardoor je minder
                inkomstenbelasting betaalt.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Boxen en tarieven
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Wil je meer informatie over 1 van de boxen? Of ben je benieuwd naar de tarieven? Bekijk dan de
                informatie op de website van de belastingdienst:<br/>
                <div class="space10"></div>

                <snelstart-ui-button iconRight="arrow-up-right-from-square" size="small"
                                     type="secondary">
                    <a href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/inkomstenbelasting/heffingskortingen_boxen_tarieven/boxen_en_tarieven/"
                       target="_blank">
                        Boxen en tarieven
                    </a>
                </snelstart-ui-button>
            </div>
        </div>
    </div>

</div>


